.betaBadge {
  display: inline-flex;
  align-items: center;
  gap: 4px;
  font-size: 16px;
  font-weight: 600;
  color: var(--color-primary);
  background-color: var(--selectable-selected);
  padding: 2px 6px;
  border-radius: 4px;
}

.betaIcon {
  width: 18px;
  height: 18px;
  color: var(--color-primary);
}